


































































import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop, Watch } from 'vue-property-decorator';
import draggable from 'vuedraggable';
import PermissionAuth from '@/components/UI/permission-auth.vue';

@Component({
  components: {
    PermissionAuth,
    draggable,
  },
})
export default class SortableGroupList extends Vue {
  @Prop()
  public permissionsKeys: any;

  @Prop({ default: false })
  public disabled: boolean;

  @Prop({ default: false })
  public showProducts: boolean;

  @Prop()
  public items: any[];

  public groups: any[] = [];

  @Watch('items')
  public onChangeItens(val): void {
    this.groups = val;
  }

  public onSubgroupCreate(group): void {
    this.$emit('subgroupCreate', group);
  }

  public onGroupEdit(group): void {
    this.$emit('groupEdit', group);
  }

  public onSubgroupEdit(subgroup, group): void {
    this.$emit('subgroupEdit', subgroup, group);
  }

  public onGroupRemove(groupId: string): void {
    this.$emit('groupRemove', groupId);
  }

  public onSubgroupRemove(subgroupId: string): void {
    this.$emit('subgroupRemove', subgroupId);
  }

  public saveMovedGroup() {
    this.groups = this._reorderItems(this.groups);
  }

  public saveMovedSubgroup(groupId: any) {
    const groupIndex = this.groups.findIndex((item) => item.id === groupId);
    if (groupIndex !== -1) {
      this.groups[groupIndex].subgrupos = this._reorderItems(
        this.groups[groupIndex].subgrupos,
      );
    }
  }

  public saveMovedProduct(groupId: any, subgroupId: any) {
    const groupIndex = this.groups.findIndex((item) => item.id === groupId);

    const subgroupIndex = this.groups[groupIndex].subgrupos.findIndex(
      (item) => item.id === subgroupId,
    );

    let products = this.groups[groupIndex].subgrupos[subgroupIndex].products;
    products = this._reorderItems(products);
  }

  public onChange(event, group) {
    const elementIsASubgroup = (element: any): boolean => !!element.grupo;
    const elementIsAProduct = (element: any): boolean =>
      !!element.grupo && !!element.subgrupo;

    const getElementType = (element: any): 'PRODUCT' | 'SUBGROUP' | 'GROUP' => {
      if (elementIsAProduct(element)) {
        return 'PRODUCT';
      }
      if (elementIsASubgroup(element)) {
        return 'SUBGROUP';
      }
      return 'GROUP';
    };

    if (!!event.moved) {
      const elementType = getElementType(event.moved.element);

      switch (elementType) {
        case 'PRODUCT':
          this.saveMovedProduct(
            event.moved.element.grupo.id,
            event.moved.element.subgrupo.id,
          );
          break;
        case 'SUBGROUP':
          this.saveMovedSubgroup(event.moved.element.grupo.id);
          break;
        case 'GROUP':
          this.saveMovedGroup();
          break;
      }

      this.$emit('moved');
    } else if (!!event.added) {
      const groupIndex = this.groups.findIndex((item) => item.id === group.id);

      if (groupIndex !== -1) {
        this.groups[groupIndex].subgrupos = this._reorderItems(
          this.groups[groupIndex].subgrupos,
        );
      }

      this.$emit('created', event.added.element, group);
    }
  }

  private _reorderItems(items: any[]): any[] {
    return items.map((item, index) => {
      item.ordem = index;
      return item;
    });
  }
}
